import type React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import type { ConnectionStatus as ConnectionStatusType } from 'services';
import { useConnectionStatusStyles } from './ConnectionStatus.styles';

interface ConnectionStatusProps {
  status: ConnectionStatusType;
  /** When true, render only the coloured dot (no text label). */
  compact?: boolean;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ status, compact = false }) => {
  const styles = useConnectionStatusStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={mergeClasses(styles.indicator, styles[status])} />
      {!compact && <span>{t(`statusPanel.connection.${status}`)}</span>}
    </div>
  );
};
